let key = {};
let env = 'demo' //production or local
if (env == 'production') {
    const API_URL = 'https://api.tossvtoss.com/'
    key = {
        CRYPTO_SECRET_KEY: "EDAFACENFTMarketPlace#%^09276!!",
        secretOrKey: "FxUum76z",
        Recaptchakey: "6LeKwCYjAAAAAMbORefOGhr-1AAXaTNTkL7MBJrV", //local
        API_URL: API_URL,
        FRONT_URL: 'https://www.tossvtoss.com',
        ADMIN_URL: 'https://contorls.tossvtoss.com/',
        getGeoInfo: "https://ipapi.co/json/",
    };
}
if (env == 'demo') {
    const API_URL = 'https://backend-edaface-listing-p2p.maticz.in/'
    key = {
        CRYPTO_SECRET_KEY: "EDAFACENFTMarketPlace#%^09276!!",
        secretOrKey: "FxUum76z",
        Recaptchakey: "6LeKwCYjAAAAAMbORefOGhr-1AAXaTNTkL7MBJrV", //local
        API_URL: API_URL,
        FRONT_URL: 'https://edafacep2p.maticz.in',
        ADMIN_URL: 'https://edafacep2p-admin.maticz.in/',
        getGeoInfo: "https://ipapi.co/json/",
    };
}
else {
    const API_URL = 'http://localhost';
    key = {
        CRYPTO_SECRET_KEY: "EDAFACENFTMarketPlace#%^09276!!",
        secretOrKey: "FxUum76z",
        Recaptchakey: "6LeHezUfAAAAAE_uuY_HFN5HoEVsQv8bpyC3xTat", //local
        API_URL: `${API_URL}:2053`,
        TRADE_URL: 'http://54.211.230.83:8081/api/trade',

        getGeoInfo: "https://ipapi.co/json/",

        socialMedia: {
            facebook: {
                appId: "1034988646970193"
            },
            linkedIn: {
                clientId: '78szlpfkw7ee7s',
                redirectUrl: 'https://99893158a13c.ngrok.io/signup',
                oauthUrl: 'https://www.linkedin.com/oauth/v2/authorization?response_type=code',
                scope: 'r_liteprofile%20r_emailaddress',
                state: '123456'
            }
        },
        FRONT_URL: 'http://localhost:3000/trade/',
        DefaultChainId: 97,
        chain_list: [97, 11155111],
    };
}

key.EnvName = env;

export default key;